export class CompanyTreeNode {
    Id: number;
    Name: string;
}